export const CONST_VIEWSTOREREDUCERFLAG = Symbol("ViewStoreReducer");
export const CONST_VIEWSTORECOMBINEREDUCERFLAGB = Symbol("ViewStoreCombineReducer");
export const CONST_VIEWSTOREACTION_INIT = Symbol("Store_Init");